
const lawsuitConsequencesStyle = {
  listStyle: {
    paddingInlineStart: "20px",
  }
};

export default lawsuitConsequencesStyle;